import srtFileDurationFeatures from '../Project/SRTFileDuration';
import noWatermarkFeatures from '../TTS/NoWatermark';

const dubbingFeatures = ({ packages }) => ({
  noWatermark: {
    key: 'no-watermark-dubbing',
    label: 'noWatermarkTextToSpeech',
    values: noWatermarkFeatures({ packages }),
  },
  srtFileDuration: {
    key: 'srt-file-duration',
    label: 'srtFileDuration',
    values: srtFileDurationFeatures({ packages }),
  },
});

export default dubbingFeatures;
